import { parse } from "bowser"

import { isBrowser } from "utils/infrastructure/ssg-utils"
export const browser = isBrowser()
    ? parse(window.navigator.userAgent)
    : {
          browser: {
              name: undefined,
              version: undefined,
          },
          os: {
              name: undefined,
              versionName: undefined,
              version: undefined,
          },
          platform: {
              type: undefined,
              vendor: undefined,
              model: undefined,
          },
      }
